import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function WhitepaperCTA() {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const handleDownloadPDF = () => {
    const printWindow = window.open('/whitepaper.html', '_blank')
    if (printWindow) {
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print()
        }, 500)
      }
    }
  }

  return (
    <section className="py-16 bg-gradient-to-br from-purple-50 via-indigo-50 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-50">
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-200 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-200 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-xl shadow-purple-200/50 border border-purple-100 p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Left: Content */}
            <div>
              <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm font-medium mb-4">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                {currentLang === 'es' ? 'Whitepaper Técnico' : 'Technical Whitepaper'}
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
                {currentLang === 'es'
                  ? 'Descubre la Ciencia detrás de FHE'
                  : 'Discover the Science Behind FHE'}
              </h2>

              <p className="text-slate-600 mb-6">
                {currentLang === 'es'
                  ? 'Nuestro whitepaper detalla la arquitectura técnica, los fundamentos matemáticos del cifrado homomórfico CKKS, y cómo garantizamos la privacidad de tus datos durante el procesamiento ML.'
                  : 'Our whitepaper details the technical architecture, the mathematical foundations of CKKS homomorphic encryption, and how we guarantee data privacy during ML processing.'}
              </p>

              <ul className="space-y-2 mb-6">
                {[
                  currentLang === 'es' ? '12 capítulos de documentación técnica' : '12 chapters of technical documentation',
                  currentLang === 'es' ? 'Fundamentos matemáticos de CKKS' : 'Mathematical foundations of CKKS',
                  currentLang === 'es' ? 'Benchmarks y comparativas de rendimiento' : 'Benchmarks and performance comparisons',
                  currentLang === 'es' ? 'Arquitectura de la plataforma' : 'Platform architecture'
                ].map((item, index) => (
                  <li key={index} className="flex items-center gap-2 text-slate-700">
                    <svg className="w-5 h-5 text-purple-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>

              <div className="flex flex-wrap gap-3">
                <button
                  onClick={handleDownloadPDF}
                  className="inline-flex items-center gap-2 bg-purple-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-purple-700 transition-colors shadow-lg shadow-purple-600/25"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  {currentLang === 'es' ? 'Descargar PDF' : 'Download PDF'}
                </button>
                <Link
                  to="/whitepaper"
                  className="inline-flex items-center gap-2 border-2 border-purple-200 text-purple-700 px-6 py-3 rounded-xl font-semibold hover:bg-purple-50 transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  {currentLang === 'es' ? 'Leer Online' : 'Read Online'}
                </Link>
              </div>
            </div>

            {/* Right: Visual */}
            <div className="hidden md:block">
              <div className="relative">
                {/* Document mockup */}
                <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500">
                  <div className="bg-white rounded-lg p-4 shadow-inner">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center">
                        <span className="text-white font-bold text-lg">X</span>
                      </div>
                      <div>
                        <div className="text-sm font-bold text-slate-900">Xcapit Privacy</div>
                        <div className="text-xs text-slate-500">Whitepaper v1.0</div>
                      </div>
                    </div>
                    <div className="space-y-2">
                      <div className="h-2 bg-slate-200 rounded w-full"></div>
                      <div className="h-2 bg-slate-200 rounded w-4/5"></div>
                      <div className="h-2 bg-slate-200 rounded w-3/4"></div>
                    </div>
                    <div className="mt-4 pt-4 border-t border-slate-100">
                      <div className="grid grid-cols-3 gap-2">
                        <div className="bg-purple-50 rounded p-2">
                          <div className="text-lg font-bold text-purple-600">12</div>
                          <div className="text-xs text-slate-500">{currentLang === 'es' ? 'Capítulos' : 'Chapters'}</div>
                        </div>
                        <div className="bg-indigo-50 rounded p-2">
                          <div className="text-lg font-bold text-indigo-600">128</div>
                          <div className="text-xs text-slate-500">bit</div>
                        </div>
                        <div className="bg-green-50 rounded p-2">
                          <div className="text-lg font-bold text-green-600">4</div>
                          <div className="text-xs text-slate-500">{currentLang === 'es' ? 'Modelos' : 'Models'}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating badge */}
                <div className="absolute -top-4 -right-4 bg-purple-600 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg animate-pulse">
                  PDF
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
